/**
 * Get in touch modal & Upload Resume modal
 * Opens from header "Get in touch" and from Upload Resume button / team page button
 */

(function() {
	'use strict';

	const getInTouchModal = document.getElementById('get-in-touch-modal');
	const uploadResumeModal = document.getElementById('upload-resume-modal');

	let lastGetInTouchTrigger = null;
	let lastUploadResumeTrigger = null;
	let scrollbarCompensation = 0;

	function getScrollbarWidth() {
		if (typeof window.innerWidth === 'number') {
			return window.innerWidth - document.documentElement.clientWidth;
		}
		return 0;
	}

	function lockScroll() {
		scrollbarCompensation = getScrollbarWidth();
		document.documentElement.style.overflow = 'hidden';
		document.body.style.overflow = 'hidden';
		if (scrollbarCompensation > 0) {
			document.body.style.paddingRight = scrollbarCompensation + 'px';
		}
		if (typeof window.evonaLenis !== 'undefined' && window.evonaLenis && typeof window.evonaLenis.stop === 'function') {
			window.evonaLenis.stop();
		}
		document.addEventListener('touchmove', preventScrollOutsideModal, { passive: false });
	}

	function unlockScroll() {
		document.removeEventListener('touchmove', preventScrollOutsideModal);
		document.documentElement.style.overflow = '';
		document.body.style.overflow = '';
		document.body.style.paddingRight = '';
		scrollbarCompensation = 0;
		if (typeof window.evonaLenis !== 'undefined' && window.evonaLenis && typeof window.evonaLenis.start === 'function') {
			window.evonaLenis.start();
		}
	}

	function preventScrollOutsideModal(e) {
		const getInTouchContent = getInTouchModal && getInTouchModal.querySelector('.get-in-touch-modal__box');
		const uploadResumeContent = uploadResumeModal && uploadResumeModal.querySelector('.get-in-touch-modal__box');
		if ((getInTouchContent && getInTouchContent.contains(e.target)) || (uploadResumeContent && uploadResumeContent.contains(e.target))) {
			return;
		}
		e.preventDefault();
	}

	function openGetInTouch(triggerEl) {
		if (!getInTouchModal) return;
		lastGetInTouchTrigger = triggerEl && triggerEl.nodeType === 1 ? triggerEl : null;
		getInTouchModal.classList.add('is-open');
		getInTouchModal.setAttribute('aria-hidden', 'false');
		lockScroll();
		const closeBtn = getInTouchModal.querySelector('[data-get-in-touch-close]');
		if (closeBtn && closeBtn.focus) {
			setTimeout(function() { closeBtn.focus(); }, 50);
		}
	}

	function closeGetInTouch() {
		if (!getInTouchModal) return;
		getInTouchModal.classList.remove('is-open');
		getInTouchModal.setAttribute('aria-hidden', 'true');
		if (!uploadResumeModal || !uploadResumeModal.classList.contains('is-open')) {
			unlockScroll();
		}
		if (lastGetInTouchTrigger && document.body.contains(lastGetInTouchTrigger)) {
			try {
				lastGetInTouchTrigger.focus({ preventScroll: true });
			} catch (err) {}
			lastGetInTouchTrigger = null;
		}
	}

	function getUploadResumeVariantFromTrigger(triggerEl) {
		if (!triggerEl || !triggerEl.getAttribute) {
			return 'default';
		}
		const raw = triggerEl.getAttribute('data-upload-resume-modal');
		if (raw === null) {
			return 'default';
		}
		const v = String(raw).trim().toLowerCase();
		if (v === '' || v === 'default') {
			return 'default';
		}
		if (v === 'team') {
			return 'team';
		}
		return 'default';
	}

	function normalizeUploadResumeVariant(variant) {
		if (variant === 'team' && uploadResumeModal && uploadResumeModal.getAttribute('data-team-fallback') === '1') {
			return 'default';
		}
		return variant;
	}

	function setUploadResumeVariant(variant) {
		if (!uploadResumeModal) {
			return;
		}
		const norm = normalizeUploadResumeVariant(variant);
		const titleEl = document.getElementById('upload-resume-modal-title');
		const da = uploadResumeModal.dataset;
		if (titleEl) {
			const def = da.defaultTitle || '';
			const team = da.teamTitle || def;
			titleEl.textContent = norm === 'team' ? team : def;
		}
		uploadResumeModal.querySelectorAll('[data-upload-resume-panel]').forEach(function(panel) {
			const key = panel.getAttribute('data-upload-resume-panel');
			const show = (norm === 'team' && key === 'team') || (norm === 'default' && key === 'default');
			if (show) {
				panel.removeAttribute('hidden');
			} else {
				panel.setAttribute('hidden', 'hidden');
			}
		});
	}

	function openUploadResume(triggerEl) {
		if (!uploadResumeModal) return;
		closeGetInTouch();
		const requested = getUploadResumeVariantFromTrigger(triggerEl);
		setUploadResumeVariant(requested);
		lastUploadResumeTrigger = triggerEl && triggerEl.nodeType === 1 ? triggerEl : null;
		uploadResumeModal.classList.add('is-open');
		uploadResumeModal.setAttribute('aria-hidden', 'false');
		lockScroll();
		const closeBtn = uploadResumeModal.querySelector('[data-upload-resume-close]');
		if (closeBtn && closeBtn.focus) {
			setTimeout(function() { closeBtn.focus(); }, 50);
		}
	}

	function closeUploadResume() {
		if (!uploadResumeModal) return;
		setUploadResumeVariant('default');
		uploadResumeModal.classList.remove('is-open');
		uploadResumeModal.setAttribute('aria-hidden', 'true');
		if (!getInTouchModal || !getInTouchModal.classList.contains('is-open')) {
			unlockScroll();
		}
		if (lastUploadResumeTrigger && document.body.contains(lastUploadResumeTrigger)) {
			try {
				lastUploadResumeTrigger.focus({ preventScroll: true });
			} catch (err) {}
			lastUploadResumeTrigger = null;
		}
	}

	// Get in touch triggers
	document.addEventListener('click', function(e) {
		const trigger = e.target.closest('[data-get-in-touch-modal]') || e.target.closest('.header__cta-link--get-in-touch');
		if (trigger) {
			e.preventDefault();
			openGetInTouch(trigger);
		}
	});

	// Upload Resume triggers (button in Get in touch modal + team page header button)
	document.addEventListener('click', function(e) {
		const trigger = e.target.closest('[data-upload-resume-modal]') || e.target.closest('.page-team__header-button');
		if (trigger) {
			e.preventDefault();
			openUploadResume(trigger);
		}
	});

	// Close Get in touch
	if (getInTouchModal) {
		getInTouchModal.addEventListener('click', function(e) {
			if (e.target.closest('[data-get-in-touch-close]')) {
				e.preventDefault();
				closeGetInTouch();
			}
			if (e.target.classList.contains('get-in-touch-modal__overlay')) {
				closeGetInTouch();
			}
		});
	}

	// Close Upload Resume
	if (uploadResumeModal) {
		uploadResumeModal.addEventListener('click', function(e) {
			if (e.target.closest('[data-upload-resume-close]')) {
				e.preventDefault();
				closeUploadResume();
			}
			if (e.target.classList.contains('get-in-touch-modal__overlay')) {
				closeUploadResume();
			}
		});
	}

	// Escape: close topmost modal
	document.addEventListener('keydown', function(e) {
		if (e.key !== 'Escape') return;
		if (uploadResumeModal && uploadResumeModal.classList.contains('is-open')) {
			closeUploadResume();
			e.preventDefault();
		} else if (getInTouchModal && getInTouchModal.classList.contains('is-open')) {
			closeGetInTouch();
			e.preventDefault();
		}
	});

	// Expose for anchor scroll (smooth-scroll-front closes modal then scrolls)
	window.evonaCloseGetInTouch = closeGetInTouch;
	window.evonaCloseUploadResume = closeUploadResume;

	// Matador shortcode: after submit, redirect returns with ?matador-apply=complete — open modal so thank-you is visible.
	(function evonaMaybeOpenUploadResumeAfterMatador() {
		if (!uploadResumeModal) {
			return;
		}
		try {
			var u = new URL(window.location.href);
			if (u.searchParams.get('matador-apply') !== 'complete') {
				return;
			}
			openUploadResume(null);
			if (window.history && window.history.replaceState) {
				u.searchParams.delete('matador-apply');
				var qs = u.searchParams.toString();
				var clean = u.pathname + (qs ? '?' + qs : '') + u.hash;
				window.history.replaceState(null, '', clean);
			}
		} catch (err) {}
	})();

	// CF7 file field: show selected filename in the drop-zone label (::before text via CSS variable).
	function evonaResetCf7FileDropLabel(input) {
		const label = input && input.closest && input.closest('label');
		if (!label) {
			return;
		}
		label.classList.remove('has-evona-cf7-file-selected');
		label.style.removeProperty('--evona-cf7-file-label');
	}

	function evonaSyncCf7FileDropLabel(input) {
		const label = input && input.closest && input.closest('label');
		if (!label) {
			return;
		}
		const file = input.files && input.files[0];
		if (file && file.name) {
			label.style.setProperty('--evona-cf7-file-label', JSON.stringify(file.name));
			label.classList.add('has-evona-cf7-file-selected');
		} else {
			evonaResetCf7FileDropLabel(input);
		}
	}

	function evonaIsCf7FileInGetInTouchModal(input) {
		return input
			&& input.matches
			&& input.matches('input.wpcf7-file[type="file"]')
			&& input.closest('.get-in-touch-modal');
	}

	document.addEventListener('change', function(e) {
		const t = e.target;
		if (!evonaIsCf7FileInGetInTouchModal(t)) {
			return;
		}
		evonaSyncCf7FileDropLabel(t);
	});

	function evonaResetAllCf7FileLabelsIn(root) {
		if (!root || !root.querySelectorAll) {
			return;
		}
		root.querySelectorAll('input.wpcf7-file[type="file"]').forEach(evonaResetCf7FileDropLabel);
	}

	// Reset label when CF7 clears the form (success) or resets; not on invalid/mailfailed — file may still be selected.
	['wpcf7mailsent', 'wpcf7reset'].forEach(function(eventName) {
		document.addEventListener(eventName, function(ev) {
			const root = ev.target;
			if (!root || !root.querySelectorAll) {
				return;
			}
			evonaResetAllCf7FileLabelsIn(root);
		});
	});
})();
